import pubQuoteSearchService from '@/services/pubQuoteSearch.service'
import { TokenService } from '@/services/storage.service'
import router from '@/router'

const state =  {
    userQuoteSearchParams: null
}

const getters = {
    userQuoteSearchParams (state) {
        return state.userQuoteSearchParams
    }
}

const actions = {
    async searchQuotesForSalesRep({commit}, payload) {
        try {
            console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await pubQuoteSearchService.searchQuotesForSalesRep(payload);
            return result
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async searchQuotesForApproval({commit}, payload) {
        try {
            console.log('searchQuotesForApproval')
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await pubQuoteSearchService.searchQuotesForApproval(payload);
            return result
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async getUserDefaultQuoteSearchCriteria({commit}) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await pubQuoteSearchService.getUserDefaultQuoteSearchCriteria();
            return result
        } catch (e) {
            return e
        } finally {
            commit('setLoading', false, { root: true })
        }
    },
    async getUserDefaultQuoteSearchLookups({commit}, payload) {
        try {
            console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await pubQuoteSearchService.getUserDefaultQuoteSearchLookups(payload);
            return result
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
 }

const mutations = {
    setUserQuoteSearchParams (state, payload) {
        state.userQuoteSearchParams = payload
    }
}

export const pubQuoteSearch = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}